import { AccessibleIcon, Box, Flex, Grid, IconPanel, LogoIcon, mdxComponents, Text } from '@workos-inc/design-system';
import { Diagram } from './diagram';

// Introducing lint rule banning type assertions
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const MdxImage = mdxComponents.Image as React.FC<React.PropsWithChildren>;
const EventDiagramGrid = ({
  children,
  columns = '80px 0 16px 1fr 48px 1fr 48px 1fr 16px'
}: React.PropsWithChildren & {
  columns?: string;
}) => <svg viewBox="0 0 688 288" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="EventDiagramGrid" data-sentry-source-file="directory-sync-diagrams-events.tsx">
    <foreignObject height="288" width="688" x="0" y="0" data-sentry-element="foreignObject" data-sentry-source-file="directory-sync-diagrams-events.tsx">
      <Diagram.Root style={{
      backgroundColor: 'var(--color-panel-solid)',
      padding: 0
    }} data-sentry-element="Diagram.Root" data-sentry-source-file="directory-sync-diagrams-events.tsx">
        <Grid align="center" style={{
        gridTemplateColumns: columns,
        gridTemplateRows: '96px 0 96px 0 96px'
      }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Box style={{
          gridRow: 2,
          gridColumn: '1 / -1'
        }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <DashedLine data-sentry-element="DashedLine" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
          </Box>

          <Box style={{
          gridRow: 4,
          gridColumn: '1 / -1'
        }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <DashedLine data-sentry-element="DashedLine" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
          </Box>

          <Box style={{
          gridRow: '1 / -1',
          gridColumn: 2,
          height: '100%'
        }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <DashedLine orientation="vertical" data-sentry-element="DashedLine" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
          </Box>

          {children}
        </Grid>
      </Diagram.Root>
    </foreignObject>
  </svg>;
const DirectoryActivated = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="DirectoryActivated" data-sentry-source-file="directory-sync-diagrams-events.tsx">
    <AccessibleIcon label="A diagram showing the sequence of events for when the directory activated event is emitted" data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx">
      <EventDiagramGrid data-sentry-element="EventDiagramGrid" data-sentry-source-file="directory-sync-diagrams-events.tsx">
        <Box style={{
        gridRow: 1,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <LogoIcon size="1" data-sentry-element="LogoIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">WorkOS</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="directory-sync-diagrams-events.tsx">
                <StackIcon data-sentry-element="StackIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              </IconPanel>
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">Provider</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 5,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <YourAppIcon data-sentry-element="YourAppIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">Your app</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 4
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Receive directory setup request</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 5
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="right" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 6
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" direction="column" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Exchange data with the provider</DiagramBox>

            <Box height="0" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <Flex gap="1" height="32px" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
                <Diagram.Arrow direction="down" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
                <Diagram.Arrow direction="up" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              </Flex>
            </Box>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 6
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox color="red" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Accept the connection</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 7
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="right" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 8
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Create directory</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 8,
        height: 128
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="down" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 5,
        gridColumn: 8
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox color="blue" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Save the directory ID and data</DiagramBox>
        </Box>
      </EventDiagramGrid>
    </AccessibleIcon>
  </MdxImage>;
const DirectoryDeleted = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="DirectoryDeleted" data-sentry-source-file="directory-sync-diagrams-events.tsx">
    <AccessibleIcon label="A diagram showing the sequence of events for when the directory deleted event is emitted" data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx">
      <EventDiagramGrid columns="80px 0 16px 1fr 64px 1fr 16px" data-sentry-element="EventDiagramGrid" data-sentry-source-file="directory-sync-diagrams-events.tsx">
        <Box style={{
        gridRow: 1,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <LogoIcon size="1" data-sentry-element="LogoIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">WorkOS</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="directory-sync-diagrams-events.tsx">
                <StackIcon fill="var(--gray-a3)" data-sentry-element="StackIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              </IconPanel>
              <Text size="1" style={{
              color: 'var(--gray-a8)'
            }} data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">
                Provider
              </Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 5,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <YourAppIcon data-sentry-element="YourAppIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">Your app</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 4
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Receive directory teardown request</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 5
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="right" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 6
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Delete directory</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 6,
        height: 128
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="down" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 5,
        gridColumn: 6
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox color="blue" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            Delete the directory, groups, and users
          </DiagramBox>
        </Box>
      </EventDiagramGrid>
    </AccessibleIcon>
  </MdxImage>;
const SftpDirectoryActivated = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="SftpDirectoryActivated" data-sentry-source-file="directory-sync-diagrams-events.tsx">
    <AccessibleIcon label="A diagram showing the sequence of events for when an SFTP directory is activated" data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx">
      <EventDiagramGrid data-sentry-element="EventDiagramGrid" data-sentry-source-file="directory-sync-diagrams-events.tsx">
        <Box style={{
        gridRow: 1,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <LogoIcon size="1" data-sentry-element="LogoIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">WorkOS</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="directory-sync-diagrams-events.tsx">
                <OrganizationIcon data-sentry-element="OrganizationIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              </IconPanel>
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">Organization</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 5,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <YourAppIcon data-sentry-element="YourAppIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">Your app</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 4
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Receive directory setup request</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 5
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="right" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 6
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" direction="column" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Create a data storage container</DiagramBox>

            <Box height="0" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <Flex gap="1" height="32px" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
                <Diagram.Arrow direction="down" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
                <Diagram.Arrow direction="up" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              </Flex>
            </Box>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 6
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox color="gray" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Upload CSV files</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 7
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="right" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 8
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Create directory</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 8,
        height: 128
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="down" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 5,
        gridColumn: 8
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox color="blue" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Register webhook event</DiagramBox>
        </Box>
      </EventDiagramGrid>
    </AccessibleIcon>
  </MdxImage>;
const GroupCreated = () => <MdxImage data-sentry-element="MdxImage" data-sentry-component="GroupCreated" data-sentry-source-file="directory-sync-diagrams-events.tsx">
    <AccessibleIcon label="A diagram showing the sequence of events for when the directory group created event is emitted" data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx">
      <EventDiagramGrid columns="80px 0 16px 1fr 32px 1fr 32px 2fr 16px" data-sentry-element="EventDiagramGrid" data-sentry-source-file="directory-sync-diagrams-events.tsx">
        <Box style={{
        gridRow: 1,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <LogoIcon size="1" data-sentry-element="LogoIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">WorkOS</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="directory-sync-diagrams-events.tsx">
                <StackIcon data-sentry-element="StackIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              </IconPanel>
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">Provider</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 5,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <YourAppIcon data-sentry-element="YourAppIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">Your app</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 4
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox color="green" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Directory group is created</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 4
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Receive create group request</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 4
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" direction="column" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Receive create group request</DiagramBox>

            <Box height="0" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <Box height="32px" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
                <Diagram.Arrow direction="up" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              </Box>
            </Box>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 5
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="right" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 6
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox p="2" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Normalize data across providers</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 7
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="right" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 8
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            Add directory group, add users, and push users into the group
          </DiagramBox>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 8,
        height: 128
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Grid columns="3" gap="1" height="100%" data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Diagram.Arrow direction="down" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
            <Diagram.Arrow direction="down" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
            <Diagram.Arrow direction="down" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
          </Grid>
        </Box>

        <Box style={{
        gridRow: 5,
        gridColumn: 8
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Grid columns="3" gap="1" style={{
          fontSize: 'var(--font-size-1)'
        }} data-sentry-element="Grid" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <DiagramBox color="blue" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Save group ID and data</DiagramBox>
            <DiagramBox color="blue" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Save user ID and data</DiagramBox>
            <DiagramBox color="blue" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">Save users in group</DiagramBox>
          </Grid>
        </Box>
      </EventDiagramGrid>
    </AccessibleIcon>
  </MdxImage>;
interface EventDiagramTemplateProps {
  accent: 'yellow' | 'blue' | 'red' | 'green';
  label: string;
  step1: string;
  step2: string;
  step3: string;
  step4: string;
  step5: string;
}
const EventDiagramTemplate = ({
  accent,
  label,
  step1,
  step2,
  step3,
  step4,
  step5
}: EventDiagramTemplateProps) => <MdxImage data-sentry-element="MdxImage" data-sentry-component="EventDiagramTemplate" data-sentry-source-file="directory-sync-diagrams-events.tsx">
    <AccessibleIcon label={label} data-sentry-element="AccessibleIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx">
      <EventDiagramGrid data-sentry-element="EventDiagramGrid" data-sentry-source-file="directory-sync-diagrams-events.tsx">
        <Box style={{
        gridRow: 1,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <LogoIcon size="1" data-sentry-element="LogoIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">WorkOS</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <IconPanel size="3" data-sentry-element="IconPanel" data-sentry-source-file="directory-sync-diagrams-events.tsx">
                <StackIcon data-sentry-element="StackIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              </IconPanel>
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">Provider</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 5,
        gridColumn: 1
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" justify="center" pt="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <Flex align="center" direction="column" gap="1" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <YourAppIcon data-sentry-element="YourAppIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              <Text size="1" data-sentry-element="Text" data-sentry-source-file="directory-sync-diagrams-events.tsx">Your app</Text>
            </Flex>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 4
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox color={accent} data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">{step1}</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 4
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Flex align="center" direction="column" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
            <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">{step2}</DiagramBox>
            <Box height="0" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
              <Box height="32px" data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
                <Diagram.Arrow direction="up" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
              </Box>
            </Box>
          </Flex>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 5
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="right" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 6
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">{step3}</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 7
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="right" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 1,
        gridColumn: 8
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">{step4}</DiagramBox>
        </Box>

        <Box style={{
        gridRow: 3,
        gridColumn: 8,
        height: 128
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <Diagram.Arrow direction="down" data-sentry-element="Diagram.Arrow" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
        </Box>

        <Box style={{
        gridRow: 5,
        gridColumn: 8
      }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx">
          <DiagramBox color="blue" data-sentry-element="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx">{step5}</DiagramBox>
        </Box>
      </EventDiagramGrid>
    </AccessibleIcon>
  </MdxImage>;
const UserCreated = () => <EventDiagramTemplate accent="yellow" label="A diagram showing the sequence of events for when the directory user created event is emitted" step1="Directory user is created" step2="Receive create user request" step3="Normalize data across providers" step4="Create directory user" step5="Save the user ID and data" data-sentry-element="EventDiagramTemplate" data-sentry-component="UserCreated" data-sentry-source-file="directory-sync-diagrams-events.tsx" />;
const UserUpdated = () => <EventDiagramTemplate accent="yellow" label="A diagram showing the sequence of events for when the directory user updated event is emitted" step1="Directory user is updated" step2="Receive update user request" step3="Normalize data across providers" step4="Update the directory user" step5="Update the user data" data-sentry-element="EventDiagramTemplate" data-sentry-component="UserUpdated" data-sentry-source-file="directory-sync-diagrams-events.tsx" />;
const UserDeleted = () => <EventDiagramTemplate accent="yellow" label="A diagram showing the sequence of events for when the directory user deleted event is emitted" step1="Directory user is deleted" step2="Receive delete user request" step3="Normalize data across providers" step4="Delete the directory user" step5="Delete the user" data-sentry-element="EventDiagramTemplate" data-sentry-component="UserDeleted" data-sentry-source-file="directory-sync-diagrams-events.tsx" />;
const GroupUpdated = () => <EventDiagramTemplate accent="green" label="A diagram showing the sequence of events for when the directory group updated event is emitted" step1="Directory group is updated" step2="Receive update group request" step3="Normalize data across providers" step4="Update the directory group" step5="Update the group data" data-sentry-element="EventDiagramTemplate" data-sentry-component="GroupUpdated" data-sentry-source-file="directory-sync-diagrams-events.tsx" />;
const GroupDeleted = () => <EventDiagramTemplate accent="green" label="A diagram showing the sequence of events for when the directory group deleted event is emitted" step1="Directory group is deleted" step2="Receive delete group request" step3="Normalize data across providers" step4="Delete the directory group" step5="Remove the group data" data-sentry-element="EventDiagramTemplate" data-sentry-component="GroupDeleted" data-sentry-source-file="directory-sync-diagrams-events.tsx" />;
const GroupUserAdded = () => <EventDiagramTemplate accent="green" label="A diagram showing the sequence of events for when the directory group user added event is emitted" step1="User is added to the group" step2="Receive add user to group request" step3="Normalize data across providers" step4="Add user to the directory group" step5="Save the user’s group membership" data-sentry-element="EventDiagramTemplate" data-sentry-component="GroupUserAdded" data-sentry-source-file="directory-sync-diagrams-events.tsx" />;
const GroupUserRemoved = () => <EventDiagramTemplate accent="green" label="A diagram showing the sequence of events for when the directory group user removed event is emitted" step1="User is removed from the group" step2="Receive remove user from group request" step3="Normalize data across providers" step4="Remove user from the group" step5="Remove the user’s group membership" data-sentry-element="EventDiagramTemplate" data-sentry-component="GroupUserRemoved" data-sentry-source-file="directory-sync-diagrams-events.tsx" />;
type DiagramBoxProps = React.ComponentPropsWithoutRef<typeof Flex> & {
  color?: 'purple' | 'yellow' | 'blue' | 'red' | 'green' | 'gray';
};
const DiagramBox = ({
  color = 'purple',
  style,
  ...props
}: DiagramBoxProps) => <Flex align="center" height="64px" justify="center" p="3" style={{
  textAlign: 'center',
  borderRadius: 'var(--radius-4)',
  background: `var(--${color}-3)`,
  color: `var(--${color}-12)`,
  ...style
}} {...props} data-sentry-element="Flex" data-sentry-component="DiagramBox" data-sentry-source-file="directory-sync-diagrams-events.tsx" />;
interface DashedLineProps extends React.ComponentPropsWithoutRef<'svg'> {
  orientation?: 'vertical' | 'horizontal';
}
const DashedLine = ({
  style,
  orientation = 'horizontal',
  ...props
}: DashedLineProps) => <svg fill="none" stroke="var(--gray-6)" strokeLinecap="round" style={{
  overflow: 'visible',
  margin: -1,
  ...style
}} xmlns="http://www.w3.org/2000/svg" {...orientation === 'horizontal' ? {
  height: 2,
  width: 8,
  viewBox: '0 0 8 2'
} : {
  width: 2,
  height: 8,
  viewBox: '0 0 2 8'
}} {...props} data-sentry-element="svg" data-sentry-component="DashedLine" data-sentry-source-file="directory-sync-diagrams-events.tsx">
    {orientation === 'horizontal' && [...Array(88).keys()].map(n => <line key={n} x1={-2 + 8 * n} x2={2 + 8 * n} y1="1" y2="1" />)}

    {orientation === 'vertical' && [...Array(40).keys()].map(n => <line key={n} x1="1" x2="1" y1={-2 + 8 * n} y2={2 + 8 * n} />)}
  </svg>;
const StackIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => <svg fill="var(--gray-a7)" height="26" viewBox="0 0 34 26" width="34" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="StackIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx">
    <path d="M2.375 0C1.478 0 0.75 0.728 0.75 1.625V4.875C0.75 5.772 1.478 6.5 2.375 6.5H31.625C32.522 6.5 33.25 5.772 33.25 4.875V1.625C33.25 0.728 32.522 0 31.625 0H2.375ZM5.625 1.625C6.522 1.625 7.25 2.353 7.25 3.25C7.25 4.147 6.522 4.875 5.625 4.875C4.728 4.875 4 4.147 4 3.25C4 2.353 4.728 1.625 5.625 1.625ZM2.375 9.75C1.478 9.75 0.75 10.478 0.75 11.375V14.625C0.75 15.522 1.478 16.25 2.375 16.25H31.625C32.522 16.25 33.25 15.522 33.25 14.625V11.375C33.25 10.478 32.522 9.75 31.625 9.75H2.375ZM5.625 11.375C6.522 11.375 7.25 12.103 7.25 13C7.25 13.897 6.522 14.625 5.625 14.625C4.728 14.625 4 13.897 4 13C4 12.103 4.728 11.375 5.625 11.375ZM2.375 19.5C1.478 19.5 0.75 20.228 0.75 21.125V24.375C0.75 25.272 1.478 26 2.375 26H31.625C32.522 26 33.25 25.272 33.25 24.375V21.125C33.25 20.228 32.522 19.5 31.625 19.5H2.375ZM5.625 21.125C6.522 21.125 7.25 21.853 7.25 22.75C7.25 23.647 6.522 24.375 5.625 24.375C4.728 24.375 4 23.647 4 22.75C4 21.853 4.728 21.125 5.625 21.125Z" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
  </svg>;
const OrganizationIcon = ({
  style,
  ...props
}: React.ComponentPropsWithoutRef<'svg'>) => <svg fill="var(--gray-a7)" height="30" style={{
  overflow: 'visible',
  ...style
}} viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="OrganizationIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx">
    <path d="M10.25 0C8.17969 0 6.5 1.67969 6.5 3.75V12.5C7.37891 12.5 8.21875 12.6758 9 12.959V3.75C9 3.05664 9.55664 2.5 10.25 2.5H25.25C25.9434 2.5 26.5 3.05664 26.5 3.75V25H15.0938C15.5527 25.7812 15.9141 26.6113 16.1484 27.5H29V3.75C29 1.67969 27.3203 0 25.25 0H10.25ZM11.5 5V7.5H16.5V5H11.5ZM19 5V7.5H24V5H19ZM11.5 10V12.5H16.5V10H11.5ZM19 10V12.5H24V10H19ZM6.5 15C3.75586 15 1.5 17.2559 1.5 20C1.5 21.3379 2.04688 22.5586 2.90625 23.457C0.591797 24.7363 -1 27.1777 -1 30H1.5C1.5 27.2266 3.72656 25 6.5 25C9.27344 25 11.5 27.2266 11.5 30H14C14 27.1777 12.4082 24.7363 10.0938 23.457C10.9531 22.5586 11.5 21.3379 11.5 20C11.5 17.2559 9.24414 15 6.5 15ZM12.0469 15C12.7012 15.7227 13.209 16.5625 13.541 17.5H16.5V15H12.0469ZM19 15V17.5H24V15H19ZM6.5 17.5C7.89648 17.5 9 18.6035 9 20C9 21.3965 7.89648 22.5 6.5 22.5C5.10352 22.5 4 21.3965 4 20C4 18.6035 5.10352 17.5 6.5 17.5ZM14 20C14 20.8789 13.8145 21.7188 13.5312 22.5H16.5V20H14ZM19 20V22.5H24V20H19Z" fill="#D3D4DB" data-sentry-element="path" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
  </svg>;
const YourAppIcon = () => <Flex align="center" justify="center" style={{
  width: 56,
  height: 56,
  overflow: 'hidden',
  margin: -4
}} data-sentry-element="Flex" data-sentry-component="YourAppIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx">
    <Flex align="center" justify="center" data-sentry-element="Flex" data-sentry-source-file="directory-sync-diagrams-events.tsx">
      <Diagram.YourAppIcon height="96" width="96" data-sentry-element="Diagram.YourAppIcon" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
      <Box style={{
      width: 96,
      height: 96,
      marginLeft: -96,
      background: 'radial-gradient(transparent, var(--color-panel-solid) 70%, var(--color-panel-solid))'
    }} data-sentry-element="Box" data-sentry-source-file="directory-sync-diagrams-events.tsx" />
    </Flex>
  </Flex>;
export const DirectorySyncDiagramsEvents = {
  DirectoryActivated,
  DirectoryDeleted,
  SftpDirectoryActivated,
  UserCreated,
  UserUpdated,
  UserDeleted,
  GroupCreated,
  GroupUpdated,
  GroupDeleted,
  GroupUserAdded,
  GroupUserRemoved
};